import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createProduct = async (formValues) => {
  const formData = new FormData();
  formData.append("BrandId", formValues.BrandId);
  formData.append("SubCategoryId", formValues.SubCategoryId);
  formData.append("CategoryId", formValues.CategoryId);
  formData.append("HSNCodeId", formValues.HSNCodeId);
  formData.append("ProductName", formValues.ProductName);
  formData.append("ProductURL", formValues.ProductURL);
  formData.append("TagCollectionIds", formValues.TagCollectionIds);
  formData.append("ProductTags", formValues.ProductTags);
  formData.append("RelatedProducts", formValues.RelatedProducts);
  formData.append("SKUCode", formValues.SKUCode);
  formData.append("Ingredients", formValues.Ingredients);
  formData.append("Origin", formValues.Origin);
  formData.append("ProductOrder", formValues.ProductOrder);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("ProductOrder", formValues.ProductOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ThumbImageFile) {
    formData.append("ThumbImageFile", formValues.ThumbImageFile);
  }
  const response = await axiosInstance.post("product", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateProduct = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("BrandId", formValues.BrandId);
  formData.append("SubCategoryId", formValues.SubCategoryId);
  formData.append("CategoryId", formValues.CategoryId);
  formData.append("HSNCodeId", formValues.HSNCodeId);
  formData.append("ProductName", formValues.ProductName);
  formData.append("ProductURL", formValues.ProductURL);
  formData.append("TagCollectionIds", formValues.TagCollectionIds);
  formData.append("ProductTags", formValues.ProductTags);
  formData.append("RelatedProducts", formValues.RelatedProducts);
  formData.append("SKUCode", formValues.SKUCode);
  formData.append("Ingredients", formValues.Ingredients);
  formData.append("Origin", formValues.Origin);
  formData.append("ProductOrder", formValues.ProductOrder);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("ProductOrder", formValues.ProductOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ThumbImageFile) {
    formData.append("ThumbImageFile", formValues.ThumbImageFile);
  } else {
    formData.append("ThumbImageFile", null);
  }
  const response = await axiosInstance.put("product", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchProducts = async () => {
  const response = await axiosInstance.get("product", { headers });
  return response.data;
};

export const fetchProductsLatestId = async () => {
  const response = await axiosInstance.get("product/latest-id", { headers });
  return response.data;
};

export const fetchProductsForReOrder = async () => {
  const response = await axiosInstance.get("product/for-re-order", { headers });
  return response.data;
};
export const fetchProductDropdowns = async () => {
  const response = await axiosInstance.get("product/dropdown", {
    headers,
  });
  return response.data;
};

export const fetchProductById = async (id) => {
  const response = await axiosInstance.get(`product/${id}`, {
    headers,
  });
  return response.data;
};

export const publishProduct = async (id) => {
  return await await axiosInstance.patch(`product/${id}/publish`, {
    headers,
  });
};

export const unPublishProduct = async (id) => {
  return await await axiosInstance.patch(`product/${id}/unpublish`, {
    headers,
  });
};
export const updateGalleryOrderService = async (orderData) => {
  const response = await axiosInstance.patch(
    `/product/update-order`,
    orderData,
    {
      headers,
    }
  );
  return response.data;
};
export const deleteProduct = async (id) => {
  return await axiosInstance.delete(`product/${id}`, { headers });
};
